import { render, staticRenderFns } from "./TopNoticePc.vue?vue&type=template&id=11312548&scoped=true&"
import script from "./TopNoticePc.vue?vue&type=script&lang=js&"
export * from "./TopNoticePc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11312548",
  null
  
)

export default component.exports